// extracted by mini-css-extract-plugin
module.exports = {"zoom-panel":"zoom-panel___fbtkK","zoom-panel-buttons":"zoom-panel-buttons___2AqTZ","btn-zoom":"btn-zoom___mGwAn","active":"active___29G6r"};